import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Footer from "./Footer";
import { blogData } from "./Array"
import { useNavigate } from "react-router";
import vector from "../Assets/images/Vector.svg";
import { ReactComponent as ArrowIcon } from "../Assets/images/Vector.svg";


function Blog() {
  const navigate = useNavigate();
  return (
    <>
      <div className="container sub-page">
        <Container style={{ padding: "60px 0 0" }}>
          <div>
            <h1 className="fw-bold text-center">Blogs</h1>
          </div>
          {/* <Row className="d-flex align-items-center mt-5">
            <Col lg={6} md={12} sm={12}>
              <Card className="contact-card"></Card>
            </Col>
            <Col lg={6} md={12} sm={12}>
              <Card className="contact-card"></Card>
            </Col>
            
          </Row>
          <Row className="mt-4">
             <Col lg={6} md={12} sm={12}>
              <Card className="contact-card"></Card>
            </Col>
          </Row> */}
           <Row className="mt-5">
          {blogData.map((blog) => (
            <Col lg={6} md={12} sm={12} key={blog.id} className="mb-4">
              <Card
                className="contact-card1"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/blog/${blog.id}`)}
              >
                {/* <Card.Body>
                  <h4>{blog.title}</h4>
                  <p>{blog.description}</p>
                </Card.Body> */}
                 <img src={blog.banner} className="blog-img" alt={blog.title} />
                  <div className="card-content">
                  <h3 className="mb-3 blog-heading">{blog.title}</h3>
                  <p className="mb-3 blog-p">{blog.shortdisc}</p>
                  <Button className="blog-btn d-flex learn align-items-center">
                    <span style={{ fontSize: "16px", fontWeight: 500 }}>
                      Learn More
                    </span>
                    <span className="arrow-wrapper">
                      <span className="arrow-bg">
                        {/* <img
                          style={{ height: "16px", width: "16px" }}
                          src={vector}
                          alt="arrow"
                        /> */}
                        <ArrowIcon className="arrow-icon" />

                      </span>
                    </span>
                  </Button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default Blog;
